import Tippy, { TippyProps } from "@tippyjs/react/headless";
import * as React from "react";
import { ThemeType } from "src/styles/theme";
import { FlattenSimpleInterpolation } from "styled-components";
import { Placement } from "tippy.js";
import {
  TooltipCloseIcon,
  TooltipCloseIconProps,
  TooltipMessage,
  TooltipTitle,
} from "./components";
import { TooltipArrow, TooltipWrapper } from "./Tooltip.components";

interface TooltipComposition {
  CloseIcon: (props: TooltipCloseIconProps) => React.ReactElement;
  Title: React.FunctionComponent;
  Message: React.FunctionComponent;
}
interface Props extends Omit<TippyProps, "render"> {
  arrow?: boolean;
  borderThemeColor?: keyof ThemeType["colors"];
  fallbackPlacements?: Placement[];
  content: React.ReactNode;
  wrapperCssHelperStyles?: FlattenSimpleInterpolation;
}

const Tooltip: React.FunctionComponent<Props> & TooltipComposition = ({
  children,
  arrow = true,
  borderThemeColor = "primary",
  fallbackPlacements = [],
  content,
  wrapperCssHelperStyles,
  ...rest
}) => {
  return (
    <Tippy
      interactive={true}
      render={attrs => (
        <TooltipWrapper
          {...attrs}
          borderThemeColor={borderThemeColor}
          helperStyles={wrapperCssHelperStyles}>
          {arrow && <TooltipArrow data-popper-arrow />}
          {content}
        </TooltipWrapper>
      )}
      offset={[0, 15]}
      popperOptions={{
        modifiers: [
          {
            name: "flip",
            options: {
              fallbackPlacements,
            },
          },
        ],
      }}
      {...rest}>
      {children}
    </Tippy>
  );
};

Tooltip.Title = TooltipTitle;
Tooltip.Message = TooltipMessage;
Tooltip.CloseIcon = TooltipCloseIcon;

export default Tooltip;
